<template>
  <toolbar />

  <main class="main" :class="'main--' + $route.name" role="main">
    <router-view :key="$route.path"/>
  </main>
</template>

<script>
import './css/style.scss';
import Toolbar from './components/Toolbar.vue';

export default {
	name: 'App',
	components: { Toolbar },
	mounted() {
		const isDev = window.location.pathname.includes('dev');

		const script = document.createElement('script');
		script.src = isDev
			? 'https://dev-api.sitesearch360.com/plugin/bundle/55446.js'
			: 'https://js.sitesearch360.com/plugin/bundle/56183.js';
		script.async = true;
		document.head.appendChild(script);


		const trackingScript = document.createElement('script');
		trackingScript.src = isDev
			? 'https://dev-services.zoovu.com/events/user-tracking-script/18108070-4811-4257-81e9-d3d0d5ad3075/js-loader'
			: '';
		document.head.appendChild(trackingScript);
	}
};
</script>

<style >

</style>